<template>
  <div>
    <v-form ref="plannerForm">
      <v-row dense no-gutters>
        <v-col cols="12">
          <v-btn-toggle color="primary" v-model="driverPlanner.monday" @change="!driverPlanner.monday ? driverPlanner.monday = false : true">
            <v-btn small :value="true">
              Monday
            </v-btn>
          </v-btn-toggle>
          <v-btn-toggle color="primary" v-model="driverPlanner.tuesday">
            <v-btn small :value="true">
              Tuesday
            </v-btn>
          </v-btn-toggle>
          <v-btn-toggle color="primary" v-model="driverPlanner.wednesday">
            <v-btn small :value="true">
              Wednesday
            </v-btn>
          </v-btn-toggle>
          <v-btn-toggle color="primary" v-model="driverPlanner.thursday">
            <v-btn small  :value="true">
              Thursday
            </v-btn>
          </v-btn-toggle>
          <v-btn-toggle color="primary" v-model="driverPlanner.friday">
            <v-btn small :value="true">
              Friday
            </v-btn>
          </v-btn-toggle>
          <v-btn-toggle color="primary" v-model="driverPlanner.saturday">
            <v-btn small :value="true">
              Saturday
            </v-btn>
          </v-btn-toggle>
          <v-btn-toggle color="primary" v-model="driverPlanner.sunday">
            <v-btn small :value="true">
              Sunday
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="12">
          <v-row dense no-gutters>
            <v-col md="6">
              <label class="cmr-label-text"></label>
              <v-menu
                ref="menu"
                v-model="driverPlanner.hourPeriodStartMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="driverPlanner.hourPeriodStartMenu"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    clearable
                    :rules="requiredRules"
                    v-model="driverPlanner.hourPeriodStart"
                    label="Start Time"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="driverPlanner.hourPeriodStart"
                  full-width
                  @click:minute="$refs.menu.save(driverPlanner.hourPeriodStart)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col md="6">
              <label class="cmr-label-text"></label>
              <v-menu
                ref="menu"
                v-model="driverPlanner.hourPeriodEndMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="driverPlanner.hoursPeriondEndMenu"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="requiredRules"
                    clearable
                    v-model="driverPlanner.hourPeriodEnd"
                    label="End Time"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="driverPlanner.hourPeriodEnd"
                  full-width
                  @click:minute="$refs.menu.save(driverPlanner.hourPeriodEnd)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-divider class="pa-2"></v-divider>
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col md="12">
          <v-card-title class="py-0">Breaks
            <v-spacer></v-spacer>
            <v-btn small color="primary" @click="addBreak">
              <v-icon small>mdi-plus</v-icon>
              Add Break
            </v-btn>
          </v-card-title>
        </v-col>
        <v-col md="12">
          <template v-for="breakDuration in driverPlanner.breaks">
            <v-row dense no-gutters>
              <v-col md="5">
                <label class="cmr-label-text"></label>
                <v-menu
                  ref="menu"
                  v-model="breakDuration.startTimeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="breakDuration.startTimeMenu"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      clearable
                      :rules="requiredRules"
                      v-model="breakDuration.hourPeriodStart"
                      label="Start Time"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    format="24hr"
                    v-model="breakDuration.hourPeriodStart"
                    full-width
                    @click:minute="$refs.menu.save(breakDuration.hourPeriodStart)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col md="5">
                <label class="cmr-label-text"></label>
                <v-menu
                  ref="menu"
                  v-model="breakDuration.endTimeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="breakDuration.endTimeMenu"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      clearable
                      :rules="requiredRules"
                      v-model="breakDuration.hourPeriodEnd"
                      label="End Time"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    format="24hr"
                    v-model="breakDuration.hourPeriodEnd"
                    full-width
                    @click:minute="$refs.menu.save(breakDuration.hourPeriodEnd)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col md="2" v-if="breakDuration.id">
                <v-btn class="mt-4" text  small color="danger" @click="removeBreak(breakDuration.id)">
                  <v-icon>mdi-delete-circle</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-divider class="pa-2"></v-divider>
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col md="12">
          <v-card-title class="py-0">Days Off
            <v-spacer></v-spacer>
            <v-btn small color="primary" @click="addDayOff">
              <v-icon small>mdi-plus</v-icon>
              Add Day
            </v-btn>
          </v-card-title>
        </v-col>
        <v-col md="12">
          <template v-for="dayOff in driverPlanner.days_off">
            <v-row dense no-gutters>
              <v-col md="5">
                <v-datetime-picker
                  :rules="requiredRules"
                  date-format="yyyy-MM-dd" label="Select Datetime" v-model="dayOff.startDate"> </v-datetime-picker>
              </v-col>
              <v-col md="5">
                <v-datetime-picker
                  :rules="requiredRules"
                  date-format="yyyy-MM-dd" label="Select Datetime" v-model="dayOff.endDate"> </v-datetime-picker>
              </v-col>
              <v-col md="2" v-if="dayOff.id">
                <v-btn class="mt-4" text  small color="danger" @click="removeDayOff(dayOff.id)">
                  <v-icon>mdi-delete-circle</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-divider class="pa-2"></v-divider>
        </v-col>
        <v-col>
          <v-btn color="success" small @click="updatePlanner">Update</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import Vue from 'vue'
import DatetimePicker from 'vuetify-datetime-picker'
import moment from 'moment'
// (Optional) import 'vuetify-datetime-picker/src/stylus/main.styl'

Vue.use(DatetimePicker)
export default {
  name: "DriverPlanner",
  props: {
    driverId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      plannerStartTimeMenu: false,
      startTime: '',
      plannerEndTimeMenu: false,
      requiredRules: [v => !!v || "This field is required"],
    }
  },
  computed: {
    driverPlannerData () {
      return this.$store.getters['planner/getDriverPlanner']
    },
    driverPlanner () {
      let driverPlanner = JSON.parse(JSON.stringify(this.driverPlannerData))
      if (driverPlanner.days_off) {
        driverPlanner.days_off.forEach(dayOff => {
          dayOff.startDate = moment(dayOff.startDate, 'YYYY/MM/DD HH:mm').format("YYYY-MM-DD HH:mm")
          dayOff.endDate = moment(dayOff.endDate, 'YYYY/MM/DD HH:mm').format("YYYY-MM-DD HH:mm")
        })
      }
      return driverPlanner
    }
  },
  methods: {
    updatePlanner () {
      if (this.$refs.plannerForm.validate()) {
        this.driverPlanner.driverId = this.driverId
        this.prepareWorkingDays()
        const planner = JSON.parse(JSON.stringify(this.driverPlanner))
        planner.days_off.forEach(dayOff => {
          dayOff.startDate = moment(dayOff.startDate).format("YYYY-MM-DD HH:mm:ss")
          dayOff.endDate = moment(dayOff.endDate).format("YYYY-MM-DD HH:mm:ss")
        })
        this.$store.dispatch('planner/updateDriverPlanner', planner).then(response => {
          this.getDriverPlanner()
          this.$snackbar.success('Driver planner updated')
          console.log(response)
        })
      } else {
        this.$snackbar.error('Please fill all the fields.')
      }
    },
    prepareWorkingDays () {
      this.driverPlanner.monday = !this.driverPlanner.monday ? false : true
      this.driverPlanner.tuesday = !this.driverPlanner.tuesday ? false : true
      this.driverPlanner.wednesday = !this.driverPlanner.wednesday ? false : true
      this.driverPlanner.thursday = !this.driverPlanner.thursday ? false : true
      this.driverPlanner.friday = !this.driverPlanner.friday ? false : true
      this.driverPlanner.saturday = !this.driverPlanner.saturday ? false : true
      this.driverPlanner.sunday = !this.driverPlanner.sunday ? false : true
    },
    removeBreak (id) {
      let findBreak = this.driverPlanner.breaks.find(bre => {
        return bre.id == id
      })
      console.log('found break', findBreak)
      if (findBreak) {
        findBreak.driverId = this.driverId
        this.$store.dispatch('planner/removeBreak', findBreak).then(response => {
          this.getDriverPlanner()
          console.log(response)
        })
      }
     
    },
    removeDayOff (id) {
      let findDayOff = this.driverPlanner.days_off.find(bre => {
        return bre.id == id
      })
      if (findDayOff) {
        findDayOff.driverId = this.driverId
        this.$store.dispatch('planner/removeDayOff', findDayOff).then(response => {
          this.getDriverPlanner()
          console.log(response)
        })
      }
     
    },
    addBreak () {
      this.driverPlannerData.breaks.push({
        hourPeriodStart: "",
        hourPeriodEnd: ""
      })
    },
    addDayOff () {
      console.log(this.driverPlannerData.days_off)
      this.driverPlannerData.days_off.push({
        startDate: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        endDate: moment(new Date()).format("YYYY-MM-DD HH:mm"),
      })
    },
    getDriverPlanner () {
      this.$store.dispatch('planner/getDriverPlanner', this.driverId)
    }
  },
  created() {
    if (this.driverId) {
      this.getDriverPlanner()
    }
  }
}
</script>

<style scoped>

</style>